import { ContainerModule, interfaces } from "inversify";
import { IocTypes } from "../ioc.types";
import IMessagesService from "../../../features/messages/IMessagesService";
import MessagesService from "../../../features/messages/MessagesService";

export const messagesModule = new ContainerModule((bind: interfaces.Bind) => {
    bind<IMessagesService>(IocTypes.MessagesService).to(MessagesService);
});